import React from 'react';
import { useSelector } from 'react-redux';
import { makeStyles } from 'tss-react/mui';

import { useIntl } from 'ha/i18n';

import { CancellationPolicy } from 'ha/components/CancellationPolicy';
import { useBillingSubscription } from 'ha/modules/BillingSubscription';
import { Grid, Typography } from '@hbf/dsl';
import { ListingCancellationPolicy } from '@ha/api/v2/types/Listing';

import { getTenantFeeRuleName } from '../selectors';

const useStyles = makeStyles()(theme => ({
  cancellationPolicyContainer: {
    paddingBottom: theme.spacing(4),
  },
}));

interface Props {
  cancellationPolicy: ListingCancellationPolicy;
}

const CancellationPolicySection: React.FC<Props> = ({
  cancellationPolicy = ListingCancellationPolicy.STRICT,
}) => {
  const { T } = useIntl();
  const { classes } = useStyles();

  const tenantFeeRuleName = useSelector(getTenantFeeRuleName);
  const { billingSubscriptionEnabled } =
    useBillingSubscription(tenantFeeRuleName);

  return (
    <Grid
      item
      container
      xs={12}
      id="cancellation-policy"
      key="listingCancellationPolicySection"
      className={classes.cancellationPolicyContainer}
      spacing={1}
    >
      <Grid item xs={12}>
        <Grid container spacing={1} alignItems="center">
          <Grid item xs="auto">
            <Typography.H3>{T('Cancellation Policy')}</Typography.H3>
          </Grid>
        </Grid>
      </Grid>
      <Grid item xs={12}>
        <CancellationPolicy
          cancellationPolicy={cancellationPolicy}
          withFooter={!billingSubscriptionEnabled}
          testLocator="Listing/CancellationPolicy"
        />
      </Grid>
    </Grid>
  );
};

export { CancellationPolicySection };
